
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomain/about/giveaway",
      function () {
        return require("private-next-pages/_subdomain/about/giveaway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomain/about/giveaway"])
      });
    }
  